export const setSourcePayouts = {
  SET_SOURCE_PAYOUTS(state, payload) {
    state.sourcePayouts = payload;
  }
};
